/// <reference path="../../typings/tsd.d.ts" /> 
module Elp.Api {
    export class Code {
        public static getCode(processConfigurationId: string,
            codeGroup: string,
            shortDescription: string): angular.IPromise<string> {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            var d = $q.defer();

            $http.post('./api/Code/GetCodeId/' + codeGroup + '/' + shortDescription + '/' + processConfigurationId,
                null).then(r => {
                 d.resolve(r.data);
            });

            return d.promise;
        }
    }
}